import { PaymentViewLayout } from 'components/Layout/PaymentViewLayout';
import React from 'react';

export const PaymentsPage = () => (
  <PaymentViewLayout title="Payments">
    <div />
  </PaymentViewLayout>
);
